export enum TrafficTicketPaymentStatusEnum {
  NotPaid = 1,
  Paid = 2,
  PaymentFail = 3,
  Reversed = 4,
  Exempt = 5,
  MarkAsPaid = 6
}